export function AddAttachment(organizationID: number, userID: number, userLogID: number, attachmentID: number): string {
	return `/v1/organizations/${organizationID}/users/${userID}/logs/${userLogID}/attachments/${attachmentID}`;
}

export function Create(organizationID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/users/${userID}/logs`;
}

export function Delete(organizationID: number, userID: number, userLogID: number): string {
	return `/v1/organizations/${organizationID}/users/${userID}/logs/${userLogID}`;
}

export function Index(organizationID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/users/${userID}/logs`;
}

export function RemoveAttachment(organizationID: number, userID: number, userLogID: number, attachmentID: number): string {
	return `/v1/organizations/${organizationID}/users/${userID}/logs/${userLogID}/attachments/${attachmentID}`;
}

export function Update(organizationID: number, userID: number, userLogID: number): string {
	return `/v1/organizations/${organizationID}/users/${userID}/logs/${userLogID}`;
}

